<template lang="pug">
  b-form-file(
    v-model="internalValue"
    :disabled="disabled"
    :state="state"
    :placeholder="placeholder"
    :browse-text="browseText"
    accept="image/*"
    :multiple="multiple"
    :capture="capture"
    @change="onChange"
  )
</template>

<script>
import Compressor from 'compressorjs'
import heic2any from "heic2any"

export default {
  props: {
    value: {
      type: [Array, File, Object, Blob],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    state: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Toca aquí para abrir la galería'
    },
    browseText: {
      type: String,
      default: 'Buscar'
    },
    capture: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    async convertHeicIfNeeded(file) {
      // Detectar si es un archivo HEIC/HEIF
      const isHeic = file.type === 'image/heic' || 
                     file.type === 'image/heif' ||
                     file.name.toLowerCase().endsWith('.heic') ||
                     file.name.toLowerCase().endsWith('.heif')
      
      if (!isHeic) {
        return file
      }

      try {
        // Convertir HEIC a JPEG
        const convertedBlob = await heic2any({
          blob: file,
          toType: 'image/jpeg',
          quality: 0.9
        })
        
        // Crear un nuevo archivo con el blob convertido
        const convertedFile = new File(
          [convertedBlob],
          file.name.replace(/\.(heic|heif)$/i, '.jpg'),
          { type: 'image/jpeg' }
        )
        
        return convertedFile
      } catch (error) {
        console.error('Error al convertir HEIC:', error)
        // Si falla la conversión, devolver el archivo original
        return file
      }
    },

    async onChange(event) {
      const files = Array.from(event.target.files)
      
      // Primero convertir archivos HEIC si es necesario
      const convertedFiles = await Promise.all(
        files.map(file => this.convertHeicIfNeeded(file))
      )
      
      // Luego comprimir todos los archivos
      const compressedFiles = convertedFiles.map(file => {
        return new Promise((resolve, reject) => {
          new Compressor(file, {
            checkOrientation: false,
            quality: 0.4,
            convertSize: 5000,
            convertTypes: ['image/png', 'image/webp', 'image/jpg', 'image/jpeg'],
            maxHeight: 720,
            maxWidth: 720,
            success(result) {
              // Convertir Blob a File si es necesario
              if (result instanceof Blob && !(result instanceof File)) {
                const fileResult = new File(
                  [result],
                  file.name,
                  { type: result.type || file.type }
                )
                resolve(fileResult)
              } else {
                resolve(result)
              }
            },
            error(err) {
              reject(err)
            }
          })
        })
      })
      
      Promise.all(compressedFiles)
        .then(compressedFiles => {
          // Si multiple=false, emitir solo el primer archivo
          // Si multiple=true, emitir el array completo
          const result = this.multiple ? compressedFiles : compressedFiles[0]
          this.$emit('input', result)
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
</script>
